<template>
  <Slide class="FleetSizeSlide"
    v-bind="{ isCurrentSlide, isStartingSlide, mayContinue }"
    :title="content.title"
    nextAction="nextSlide"
  >
    <SingleOptionSelect
      name="inseegoFleetFleetSize"
      :options="content.options"
      :value="fieldValues.inseegoFleetFleetSize"
      :disabled="!isCurrentSlide"
      @selectionChange="doUpdateField"
    />
  </Slide>
</template>

<script>
import { slideProps } from '../util/slideBuilders.js'

import SingleOptionSelect from './elems/SingleOptionSelect.vue'
import Slide from './elems/Slide.vue'

export default {
  inject: ['updateField', 'nextSlide'],
  components: {
    Slide,
    SingleOptionSelect,
  },
  props: slideProps,
  computed: {
    mayContinue() {
      return Boolean(this.fieldValues.inseegoFleetFleetSize)
    },
  },
  methods: {
    doUpdateField(value) {
      this.updateField?.('inseegoFleetFleetSize', value, 'sync')
      this.nextSlide?.()
    },
  },
  created() {
    // As of Aug 2024, the jarvis fleet lead submission handler fails if the
    // fleet size field is missing, which happens when this slide is disabled
    // (i.e., when the short form variant is used -- currently only
    // https://inseego.com/de/lp/tachograph/).
    if (!this.fieldValues.inseegoFleetFleetSize) {
      this.updateField?.('inseegoFleetFleetSize', '')
    }
  },
}
</script>
